import { createNode } from '@glueapp/graph-types';

export const JoinTextList = createNode({
    id: 'Join Text List',
    name: 'Join Text List',
    description: 'Joins a list of texts together into one text, placing the separator between each Text in the list.',
    aiDescription:
        'Joins an array of strings into a single string with a separator. Connect a string array to "Input" and the delimiter to "Separator"; outputs the joined string on "Output".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: {
            kind: 'array',
            subType: {
                kind: 'string',
            },
        },
        Separator: { kind: 'string' },
    },
    outPorts: {
        Output: { kind: 'string' },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input.join(input.inPorts.Separator) } };
    },
});
